import { NgModule, PLATFORM_ID, Inject } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { DpDatePickerModule } from 'ng2-date-picker';
import { LottieModule } from 'ngx-lottie';
import { isPlatformBrowser } from '@angular/common';

@NgModule({
  imports: [
    GoogleMapsModule,
    DpDatePickerModule,
    LottieModule.forRoot({ player: () => import('lottie-web') }),
  ],
  exports: [GoogleMapsModule, DpDatePickerModule, LottieModule],
})
export class BrowserFeaturesModule {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (!isPlatformBrowser(this.platformId)) {
      // Do nothing on server
      return;
    }
  }
}